import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {SettingsService} from 'src/app/services/settings.service';
import {
  citizenGetServicesDeliveryChannels
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.actions';
import {
  CitizensServicesDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.model';
import {
  selectModifiedServiceDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.selectors';
import {AppState} from 'src/app/store/reducers';

@Component({
  selector: 'app-citizen-services-delivery-channel',
  templateUrl: './citizen-services-delivery-channel.component.html',
  styleUrls: ['./citizen-services-delivery-channel.component.scss']
})
export class CitizenServicesDeliveryChannelComponent implements OnInit {

  @Input() serviceUniqueId: string;
  serviceChannels$: Observable<CitizensServicesDeliveryChannel []>

  constructor(
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private settingsService: SettingsService) { }

  ngOnInit(): void {

    this.store.dispatch(citizenGetServicesDeliveryChannels({
      serviceUniqueId: this.serviceUniqueId
    }))

    this.serviceChannels$ = this.store.pipe(select(selectModifiedServiceDeliveryChannel))

  }

}
